export const environment = {
  production: true,
  version: require('../../package.json').version,
  apiBase: 'https://api.poured.us/',
  loginUrl: 'https://api.poured.us/login',
  whitelistedDomains: ['https://api.poured.us/', 'http://api.poured.us/', 'https://admin.poured.us/'],
  GoogleApiKey: 'AIzaSyBqgEtJz9zFA8If-YXrvXBcVuxmoueAWUw',
  s3Bucket: 'api-attachments',
};



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/environments/environment.ts